<template>
  <div class="chart-wrap" ref="barChartWrap" />
</template>
<script>
import { Chart } from '@/utils/g2'
import { formatNum } from '@/utils/strUtil'
export default {
  name: 'DataFans',
  props: {
    chartHeight: {
      type: Number,
      default: 400
    },
    chartData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    chartData(newVal) {
      this.initChart(newVal)
    }
  },
  created() {
    this.barChart = null
    this.initChart(this.chartData)
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    initChart(data = []) {
      const { barChartWrap } = this.$refs
      if (barChartWrap) {
        if (this.barChart) {
          this.updateChart(data)
        } else {
          this.renderChart(barChartWrap, data)
        }
      } else {
        this.$nextTick(() => {
          this.initChart(data)
        })
      }
    },
    renderChart(container, data) {
      this.barChart = new Chart({
        container,
        autoFit: true,
        width: 470,
        height: this.chartHeight,
        padding: [50, 60, 80, 90]
      })
      this.barChart.data(data)
      this.barChart.axis('name', {
        label: {
          offset: 12
        }
      })
      this.barChart.axis('value', {
        label: {
          offset: 15
        }
      })
      this.barChart.tooltip({
        domStyles: {
          'g2-tooltip': {
            width: '220px',
            padding: '8px 12px'
          },
          'g2-tooltip-title': {
            marginBottom: '10px'
          },
        },
        itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>数量: {value}</li>'
      })
      this.barChart.scale('value', {
        formatter(val) {
          return formatNum(val)
        }
      })
      this.barChart.coordinate().transpose()
      this.barChart.interval().position('name*value').color('#6077F9')
      this.barChart.render()
    },
    updateChart(data) {
      this.barChart.changeData(data)
    },
    destroyChart() {
      if (this.barChart) {
        this.barChart.destroy()
        this.barChart = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  height: 400px;
}
</style>
